
import AppTotals from "@/components/products-table/Totals.vue";
import { FrequencyDocumentEditState } from "@/utils/frequency-document-edit-state";
import Vue from "vue";
import TheBreadcrumb from "../sales/SaleEditBreadcrumb.vue";
import TheProperties from "../sales/SaleEditProperties.vue";
import TheTable from "../sales/SaleEditTable.vue";
import TheSaveModal from "./FrequencyDocumentSaveModal.vue";

export default Vue.extend({
	props: {
		state: {
			type: Object as () => FrequencyDocumentEditState,
			required: true
		}
	},
	watch: {
		"state.saveModal"(value:boolean) {
			if (!value) {
				return;
			}
			if (!this.state.doc.Sale) return;

			this.state.doc.Sale.Rows.forEach((row, index) => {
				row.DisplayOrder = index + 1;
			});
		}
	},
	components: {
		TheBreadcrumb,
		TheProperties,
		TheTable,
		TheSaveModal,
		AppTotals
	}
});
